<ng-container [ngSwitch]="searchInput?.type">
  <ng-container *ngSwitchCase="'source-resolver'">
    <asax-header-search-input-source-resolver [searchInput]="searchInput"
                                              (outFilter)="onFilter($event)">
    </asax-header-search-input-source-resolver>
  </ng-container>
  <ng-container *ngSwitchCase="'switch'">
    <asax-header-search-input-switch [searchInput]="searchInput"
                                     (outFilter)="onFilter($event)">
    </asax-header-search-input-switch>
  </ng-container>
  <ng-container *ngSwitchCase="'dropdown'">
    <asax-header-search-input-dropdown [searchInput]="searchInput"
                                       (outFilter)="onFilter($event)">
    </asax-header-search-input-dropdown>
  </ng-container>
  <ng-container *ngSwitchCase="'typeahead'">
    <asax-header-search-input-typeahead [searchInput]="searchInput"
                                        (outFilter)="onFilter($event)">
    </asax-header-search-input-typeahead>
  </ng-container>
  <ng-container *ngSwitchCase="'science-keywords'">
    <asax-header-search-input-science-keywords [searchInput]="searchInput"
                                               (outFilter)="onFilter($event)">
    </asax-header-search-input-science-keywords>
  </ng-container>
  <ng-container *ngSwitchCase="'sky-objects'">
    <asax-header-search-input-sky-objects [searchInput]="searchInput"
                                          (outFilter)="onFilter($event)">
    </asax-header-search-input-sky-objects>
  </ng-container>
  <ng-container *ngSwitchCase="'target-list'">
    <asax-header-search-input-target-list [searchInput]="searchInput"
                                          (outFilter)="onFilter($event)">
    </asax-header-search-input-target-list>
  </ng-container>
  <ng-container *ngSwitchCase="'text'">
    <asax-header-search-input-text [searchInput]="searchInput"
                                   (outFilter)="onFilter($event)">
    </asax-header-search-input-text>
  </ng-container>
</ng-container>
